// The sign-in flow itself: a 401 here is the answer (wrong password, dead refresh token),
// so these never trigger refresh-and-replay. Every other call, /auth/me included, does (B-15).
const SIGN_IN_FLOW = ['/auth/login', '/auth/signup', '/auth/refresh', '/auth/logout', '/auth/challenge', '/auth/forgot', '/auth/reset'];

/** Should a 401 from this API path try one silent refresh and replay the request? */
export function refreshesOn401(path: string): boolean {
  const bare = path.split('?')[0];
  return !SIGN_IN_FLOW.some((p) => bare === p || bare.startsWith(`${p}/`));
}
